import React, { useCallback } from 'react';

export interface SplitterProps {
    direction: 'horizontal' | 'vertical';
    onMouseDown: (e: React.MouseEvent) => void;
    isResizing: boolean;
    className?: string;
}

const Splitter: React.FC<SplitterProps> = ({
    direction,
    onMouseDown,
    isResizing,
    className = ''
}) => {
    const handleMouseDown = useCallback((e: React.MouseEvent) => {
        e.preventDefault();
        onMouseDown(e);
    }, [onMouseDown]);

    const baseClass = direction === 'horizontal' ? 'resize-handle' : 'resize-handle-vertical';
    const fullClass = `${baseClass} ${isResizing ? 'resizing' : ''} ${className}`.trim();

    return (
        <div
            className={fullClass}
            onMouseDown={handleMouseDown}
        />
    );
};

export default Splitter;
